export default __webpack_public_path__ + "static/P22MackinacPro-BookItalic-2f779e7594153017a5896da7f4817625.woff";